const colours = {
    lemon: '#fff954',
    grey: '#6b6c6f',
    red: '#E63C32'
}

export default colours
